/**
 * Created by jonas on 2019-08-21.
 */

import {Timeline, TimelineLite} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpacierArcadeGameModuleConfig} from "../SpacierArcadeGameModuleConfig";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {SpacierArcadeSoundConfig} from "../SpacierArcadeSoundConfig";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SAFreespinEvent} from "../background/SABackground";

export class WinEnd implements GameRoundPresentation {

    stagger?:number;
    abortStagger?:number;
    private _hasWin:boolean;
    private _tl:TimelineLite;

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public prepare(data:ParsedGameData):void {
        this._hasWin = data.singleWin > 0;
    }

    private hasWild(data:SpacierArcadeParsedGameData):boolean{
        let returnValue:boolean = false;
        data.overlayWildsMultipliers.filter((multi, index) => {
            if(multi.indexOf(1) > -1){
                returnValue = true;
            }
        });
        return returnValue;
    }

    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null {
        this._tl = new TimelineLite();
        if(data.mode !== SpacierArcadeGameMode.NORMAL && data.scatterPositions!.filter((pos) => {return pos > -1}).length > 0){
            this._tl.add(() => {
                EventHandler.dispatchEvent(new GameEvent(SAFreespinEvent.UPDATE_FREE_SPIN_COUNT, data.freespinsLeft));
            })
        }
        if(data.isBigWin) {
            this._tl.add([
                () => {
                    SlotGame.sound.stopEffect(SpacierArcadeSoundConfig.instance.BIG_WIN_COUNTUP);
                    SpacierArcadeGameModuleConfig.saCountupView.abort(data.totalSpinWinnigs);
                    SpacierArcadeGameModuleConfig.saBigWinView.end(data.currentTotalWinRatioConfig!, 0.5, 0.1);
                    SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.BIG_WIN_ENDS);
                    SlotGame.sound.fadeAmbience(1, 2000);
                }
            ], 0);
            this._tl.add(
                () => {
                    SlotGame.sound.stopEffect(SpacierArcadeSoundConfig.instance.BIG_WIN);
                });
            this._tl.add( () => SpacierArcadeGameModuleConfig.saCountupView.moveCountUp(data.totalSpinWinnigs, 0.5, 0.1, data.payoutMultiplier == 1 && this.hasWild(data), data.totalWinWaysWon), 0.5);
        }
        return this._tl;
    }

    public abort(isActive:boolean, data:SpacierArcadeParsedGameData):Timeline | null {
        if(isActive && this._tl) {
            GameRoundManager.detachAndPlayTimeline(this._tl);
        }
        else {
            if(this._hasWin) {
                this.getAnimation(data);
            }
        }
        return null;
    }
}